import {createReducer, on} from "@ngrx/store";
import {DocumentActions, WorkingGroupsActions} from "../actions";
import {DocumentObject} from "../../models";

export const documentFeatureKey = 'document';

export interface DocumentState {
  document: DocumentObject;
}

const initialState: DocumentState = {
  document: null,
};

export const documentReducer = createReducer(
  initialState,
  on(DocumentActions.downloadDocumentSuccess, (state, { document }) => ({ ...state, document })),
  on(WorkingGroupsActions.getWorkingGroups, (state) => ({ ...initialState })),
);
